import { render } from "./addedit.vue?vue&type=template&id=3b06ba41&scoped=true"
import script from "./addedit.vue?vue&type=script&lang=js"
export * from "./addedit.vue?vue&type=script&lang=js"

import "./addedit.vue?vue&type=style&index=0&id=3b06ba41&scoped=true&lang=css"

import exportComponent from "C:\\Users\\erenk\\source\\repos\\erenkorkmaz53\\eTalep\\eCampus\\eCampus.WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b06ba41"]])

export default __exports__